export default __webpack_public_path__ + "static/media/plus1.091ce35c.svg";